import { z } from "zod"

/**
 * EmailSchema
 */

export const EmailSchema = z.object({
  sendTo: z.string().nonempty('Este campo deve ser preenchido!'),
  subject: z.string().nonempty('Este campo deve ser preenchido!'),
  body: z.string().default(''),
  attachment: z.string().default(''),
});

/**
 * EmailForm
 */

export type EmailForm = z.infer<typeof EmailSchema>;